import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    updateIdentityRegionaleRequest: ['response'],
    updateIdentityRegionaleSuccess: ['response'],
    updateIdentityRegionaleFailure: ['error'],
})

export const updateIdentityRegionaleTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const updateIdentityRegionaleRequest = state =>
    state.merge({ success: null, loading: true })

const updateIdentityRegionaleSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        loading: false,
        response,
    })

const updateIdentityRegionaleFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        loading: false,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.UPDATE_IDENTITY_REGIONALE_REQUEST]: updateIdentityRegionaleRequest,
    [Types.UPDATE_IDENTITY_REGIONALE_SUCCESS]: updateIdentityRegionaleSuccess,
    [Types.UPDATE_IDENTITY_REGIONALE_FAILURE]: updateIdentityRegionaleFailure,
})
